module.exports = __webpack_public_path__ + "img/645-0df9de.png";